import React, { Component } from 'react';
import firebase from './config/fireConfig'
import { BrowserRouter , Switch , Route} from 'react-router-dom'
import Navbar from './components/layout/Navbar';
import Dashboard from './components/dashboard/Dashboard'
import SignIn from './components/auth/SignIn';
import SignUp from './components/auth/SignUp';
import Footer from './components/layout/Footer';

import Projects from './components/projects/Projects';
import CreateProject from './components/projects/CreateProject';
import ProjectDetails from './components/projects/ProjectDetails';

import Navigations from './components/navigation/Navigations';
import CreateNavigation from './components/navigation/CreateNavigation';


import CreateForm from './components/create-form/CreateForm';
import Forms from './components/create-form/form';
import List from './components/dynamic-form/List';


import CreateUser from './components/users/CreateUser';
import Users from './components/users/Users';
import Tasks from './components/projects/tasks/Tasks';
import UserDashboard from './components/dashboard/UserDashboard';
import ForgotPassword from './components/auth/ForgotPassword';




class App extends Component {

  /*
  componentDidMount(){
    const messaging = firebase.messaging()
    messaging.requestPermission().then(()=>{
      return messaging.getToken()
    }).then(token=>{
      console.log('Token : ',token)
    }).catch((err)=>{
      console.log(err);
      
    })
    messaging.onMessage((payload)=>{
      console.log('onMessage : ', payload);
    })
    //navigator.serviceWorker.addEventListener("message", (message) => console.log(message));
  }*/

  render() {
    return (
      
          <BrowserRouter>
          <div>
            <Navbar/>

          <Switch>
            <Route exact path='/'component={Dashboard} />
            <Route path='/signin' component ={SignIn}/>
            {/* <Route path='/signup' component ={SignUp}/> */}
            <Route path='/create-project' component ={CreateProject}/>
            <Route path='/edit-project/:projectId' component ={CreateProject}/>
            
            <Route path='/project/:id/:tabId' component ={ProjectDetails}/>
            <Route path='/project/:id' component ={ProjectDetails}/>

            <Route path='/projects' component ={Projects}/>

            <Route path='/create-navigation' component ={CreateNavigation}/>
            <Route path='/edit-navigation/:id' component ={CreateNavigation}/>
            <Route path='/navigations' component ={Navigations}/>
            <Route path='/create-form' component ={CreateForm}/>
            <Route path='/forms' component ={Forms}/>

            <Route path='/dynamic/:firestoreList/:formId' component ={List}/>
            {/* <Route path='/dynamic/add/:firestoreList/:formId' component ={List}/> */}


            <Route path='/create-user' component ={CreateUser}/>
            <Route path='/users' component ={Users}/>
            <Route path='/edit-user/:userId' component ={CreateUser}/>
            <Route path='/tasks' component ={Tasks}/>
            <Route path='/task/:taskId' component ={Tasks}/>

            <Route path='/user-dashboard/:userId' component ={UserDashboard}/>
            <Route path='/forgot-password' component ={ForgotPassword}/>

          </Switch>

         {  /* <Footer/>  */}
          </div>
          </BrowserRouter>  
      
    );
  }
}

export default App;
